import { render } from "./RecensementDashboard.vue?vue&type=template&id=be6e6e32&ts=true"
import script from "./RecensementDashboard.vue?vue&type=script&lang=ts"
export * from "./RecensementDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__